const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2475 2500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2305.18,1046.98L287.756,16.55C287.756,16.55 155.925,0 101.549,35.017C41.59,73.625 20.842,202.769 20.842,202.769L20.842,2263.64C20.842,2263.64 39.426,2417.18 101.537,2456.08C171.663,2500 337.423,2437.45 337.423,2437.45L2323.8,1419.43C2323.8,1419.43 2454.16,1338.73 2454.16,1227C2454.16,1115.26 2305.18,1046.98 2305.18,1046.98Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.563,1133.74L790.563,897.857L958.168,897.857L958.168,1133.74L1200.26,1133.74L1200.26,1301.34L958.168,1301.34L958.168,1531.02L790.563,1531.02L790.563,1301.34L542.264,1301.34L542.264,1133.74L790.563,1133.74Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabview);
export default __webpack_public_path__ + "static/media/labview.6dbb65b415325a5a86bb64a346c19d18.svg";
export { ForwardRef as ReactComponent };